import { createI18n } from 'vue-i18n';

// English translations
const en = {
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Overview of your educational platform',
    buttons: {
      view_all: 'View All'
    },
    courses: {
      most_watched: 'Most Watched Courses',
      most_subscribed: 'Most Subscribed Courses',
      no_data: 'No courses found'
    },
    charts: {
      revenue: {
        title: 'Revenue Overview'
      },
      activity: {
        title: 'User Activity',
        periods: {
          daily: 'Daily',
          weekly: 'Weekly',
          monthly: 'Monthly'
        }
      }
    },
    error: {
      title: 'Error loading dashboard',
      generic: 'Something went wrong. Please try again.',
      retry: 'Retry'
    },
    platform: {
      title: 'Platform Usage'
    },
    timeframes: {
      '7d': 'Last 7 Days',
      '30d': 'Last 30 Days',
      '90d': 'Last 90 Days'
    },
    component: {
      title: 'Component',
      no_data: 'No data available',
      toggle: 'Toggle'
    }
  }
};

// Arabic translations
const ar = {
  dashboard: {
    title: 'لوحة المعلومات',
    subtitle: 'نظرة عامة على منصتك التعليمية',
    buttons: {
      view_all: 'عرض الكل'
    },
    courses: {
      most_watched: 'الدورات الأكثر مشاهدة',
      most_subscribed: 'الدورات الأكثر اشتراكًا',
      no_data: 'لا توجد دورات'
    },
    charts: {
      revenue: {
        title: 'نظرة عامة على الإيرادات'
      },
      activity: {
        title: 'نشاط المستخدم',
        periods: {
          daily: 'يومي',
          weekly: 'أسبوعي',
          monthly: 'شهري'
        }
      }
    },
    error: {
      title: 'خطأ في تحميل لوحة المعلومات',
      generic: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
      retry: 'إعادة المحاولة'
    },
    platform: {
      title: 'استخدام المنصة'
    },
    timeframes: {
      '7d': 'آخر 7 أيام',
      '30d': 'آخر 30 يوم',
      '90d': 'آخر 90 يوم'
    },
    component: {
      title: 'مكون',
      no_data: 'لا توجد بيانات متاحة',
      toggle: 'تبديل'
    }
  }
};

// Create i18n instance
export const i18n = createI18n({
  legacy: false, // Use the Composition API
  locale: 'en', // Set default locale
  fallbackLocale: 'en',
  messages: {
    en,
    ar
  }
});

export default i18n; 